import { CompanyPage } from "@/features/company/pages/Company";

const Company = () => {
  return <CompanyPage />;
};

export default Company;
